import Vue from 'vue'

/**
 * EventBus
 *
 * Import pristine vue, because we don't need all the plugins in that instance
 */
const EventBus = {
  queue: [],

  /**
   * Remove ALL bus listeners
   */
  beforeDestroy () {
    this.$bus.$off()
  },

  emitQueuedEvents(key) {
    if (this.queue.find(event => event.key === key)) {
      this.queue.forEach(({ key, payload }, index) => {
        this.$emit(key, payload)
        this.queue.splice(index, 1)
      })
    }
  },

  list () {
    return this.$bus?._events ?? {}
  },

  /**
   * Emitted the event to the bus
   *
   * All events before registration are queued and reissued after registration
   *
   * @param {String} key
   * @param {any} payload
   */
  $emit (key, payload = null) {
    if (this.list()[key]) {
      this.$bus.$emit(key, payload)
    } else {
      this.queue.push({ key, payload })
    }
  },

  /**
   * Unregisters an event
   *
   * @param {Array|String} keys
   * @param {Function} callback
   */
  $off (keys, callback) {
    if (!Array.isArray(keys)) {
      keys = [keys]
    }

    keys.forEach(key => {
      this.$bus.$off(key, callback)
    })
  },

  /**
   * Registers new event listeners, that are listenend to only once!
   *
   * @param {Array|String} keys
   * @param {Function} callback
   */
  $once (keys, callback) {
    if (!Array.isArray(keys)) {
      keys = [keys]
    }

    keys.forEach(key => {
      this.$bus.$once(key, callback)

      this.emitQueuedEvents(key)
    })
  },
  /**
   * Registers new event listeners
   *
   * @param {Array|String} keys
   * @param {function(*): void} callback
   */
  $on (keys, callback) {
    if (!Array.isArray(keys)) {
      keys = [keys]
    }

    keys.forEach(key => {
      this.$bus.$on(key, callback)
      this.emitQueuedEvents(key)
    })
  },

  install(Vue) {
    this.$bus = new Vue()
    Vue.prototype.$EventBus = this
  }
}

export default EventBus
